import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "../lib/api";
import { Check, X, ArrowRight, Loader2 } from "lucide-react";

export default function CheckoutSuccess() {
  const { search } = useLocation();
  const sessionId = new URLSearchParams(search).get("session_id");
  const [status, setStatus] = useState("checking");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setData(data);
        if (data.payment_status === "paid") setStatus("paid");
        else if (data.status === "expired") setStatus("expired");
        else if (attempts < 6) { attempts++; setTimeout(poll, 2000); }
        else setStatus("timeout");
      } catch (e) { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <section className="section hero-radial min-h-[70vh] flex items-center">
      <div className="container-if max-w-xl mx-auto">
        <div className="card-cream p-10 text-[var(--if-ink)] text-center">
          {status === "checking" && (
            <>
              <Loader2 className="w-10 h-10 mx-auto mb-5 text-[var(--if-olive)] animate-spin" />
              <h1 className="font-display text-3xl mb-2">Confirming your payment…</h1>
              <p className="text-sm text-[rgba(27,29,25,0.7)]">Hold tight — we're verifying with Stripe.</p>
            </>
          )}
          {status === "paid" && (
            <>
              <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-[var(--if-olive)] flex items-center justify-center">
                <Check className="w-7 h-7 text-[var(--if-cream)]" />
              </div>
              <h1 className="font-display text-3xl mb-2">Mission funded.</h1>
              <p className="text-sm text-[rgba(27,29,25,0.7)] mb-5">
                Your payment of ${((data?.amount_total || 0) / 100).toFixed(2)} has been received. A strategist will contact you within 24 hours.
              </p>
              <Link to="/dashboard" className="btn-gold" data-testid="checkout-to-dashboard">
                Go to Dashboard <ArrowRight className="w-4 h-4" />
              </Link>
            </>
          )}
          {(status === "expired" || status === "error" || status === "timeout") && (
            <>
              <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-red-500/10 flex items-center justify-center">
                <X className="w-7 h-7 text-red-500" />
              </div>
              <h1 className="font-display text-3xl mb-2">Something went off-target.</h1>
              <p className="text-sm text-[rgba(27,29,25,0.7)] mb-5">
                {status === "expired" ? "Your checkout session expired." : "We couldn't confirm payment status."}
              </p>
              <Link to="/services" className="btn-outline">Back to Services</Link>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
